const getDrawerTypeFromTicketType = (ticketType) => {
	const drawerMap = new Map([
		[1, 'AmbulatoryQuoteDrawer'],
		[2, 'AmbulatoryQuoteDrawer'],
		[3, 'TicketDrawer'],
		[4, 'TicketDrawer'],
		[5, 'TicketDrawer'],
		[6, 'TicketDrawer'],
		[7, 'TicketDrawer'],
		[8, 'TicketDrawer'],
		[9, 'TicketDrawer'],
	])

	return drawerMap.get(ticketType)
}

export default getDrawerTypeFromTicketType
